/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AccountService } from './services/account.service';
import { AnswerService } from './services/answer.service';
import { AttachmentService } from './services/attachment.service';
import { ContactService } from './services/contact.service';
import { CountryService } from './services/country.service';
import { EngineerService } from './services/engineer.service';
import { JobService } from './services/job.service';
import { JobEngineerService } from './services/job-engineer.service';
import { JobWorkService } from './services/job-work.service';
import { LookupService } from './services/lookup.service';
import { SiteService } from './services/site.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AccountService,
    AnswerService,
    AttachmentService,
    ContactService,
    CountryService,
    EngineerService,
    JobService,
    JobEngineerService,
    JobWorkService,
    LookupService,
    SiteService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
